import { useCallback, useEffect } from 'react';

const EVENT_OPTIONS = { passive: true };

const useScheduleKeyboardShortcuts = (showDeleted, setShowDeleted) => {
  const handleKeyUp = useCallback(
    e => {
      if (e.ctrlKey && e.shiftKey && e.key === 'X') {
        setShowDeleted(!showDeleted);
      }
    },
    [setShowDeleted, showDeleted]
  );

  useEffect(() => {
    document.addEventListener('keyup', handleKeyUp, EVENT_OPTIONS);

    return () => {
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, [showDeleted, handleKeyUp]);
};

export default useScheduleKeyboardShortcuts;
